import SEO from "../components/SEO";
import FAQ from "../components/FAQ";

export default function FAQPage() {
  return (
    <>
      <SEO
        title="FAQ | Aligned Education Systems"
        description="Answers to the questions K–12 school and district leaders ask most often about AlignED's weekly operational systems."
      />
      <section className="bg-[#FDFBF7] border-b border-[#0A192F]/10" data-testid="faq-hero">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-20 pb-14 lg:pt-24 lg:pb-20">
          <div className="text-xs uppercase tracking-[0.2em] text-[#52796F]">FAQ</div>
          <h1 className="mt-6 font-serif-display text-4xl sm:text-5xl lg:text-6xl text-[#0A192F] leading-[1.05] max-w-4xl">
            What K–12 Leaders Ask Before Bringing In a New System
          </h1>
          <p className="mt-6 text-lg text-[#4A5568] leading-relaxed max-w-2xl">
            Straight answers — no marketing veneer.
          </p>
        </div>
      </section>
      <FAQ testid="faq-page-section" heading="The Questions That Come Up Most" />
    </>
  );
}
